/* misura.js — tre cose, e nessuna tocca il calcolo del prezzo.
   1) disegna il rettangolo con le proporzioni reali del tatuaggio;
   2) colora la parte percorsa dei due cursori;
   3) fa comparire la barra del prezzo in basso, ma solo quando serve.

   Se questo file non parte, la pagina continua a funzionare esattamente
   come prima: script.js non lo conosce e non lo aspetta. */
(function () {
  'use strict';

  var MAX = 50; // il massimo dei due cursori, in centimetri

  function avvia() {
    var altezza = document.getElementById('altezza');
    var larghezza = document.getElementById('larghezza');
    if (!altezza || !larghezza) return;

    /* ── il rettangolo e il riempimento dei cursori ─────────────────────── */
    var forma = document.querySelector('.am-forma');

    function riempi(cursore) {
      var min = +cursore.min || 0, max = +cursore.max || 100;
      cursore.style.setProperty('--percorso', ((+cursore.value - min) / (max - min)) * 100 + '%');
    }

    function disegna() {
      if (forma) {
        forma.style.height = (Math.min(+altezza.value, MAX) / MAX * 100) + '%';
        forma.style.width = (Math.min(+larghezza.value, MAX) / MAX * 100) + '%';
      }
      riempi(altezza);
      riempi(larghezza);
    }

    altezza.addEventListener('input', disegna);
    larghezza.addEventListener('input', disegna);
    disegna();

    /* ── la barra del prezzo ────────────────────────────────────────────────
       Regola: compare solo quando TUTTE e due sono vere — la persona ha
       toccato qualcosa, e il prezzo vero e uscito dallo schermo. Cosi chi
       arriva non si trova davanti una cifra che non ha chiesto, e chi sta
       configurando non perde mai di vista il risultato.                    */
    var barra = document.querySelector('.barra-prezzo');
    var prezzo = document.getElementById('prezzo');
    var riquadro = document.querySelector('.price-container');
    if (!barra || !prezzo || !riquadro) return;

    var numero = barra.querySelector('.bp-numero');
    var toccato = false;
    var fuoriVista = false;

    function aggiorna() {
      var mostra = toccato && fuoriVista;
      barra.classList.toggle('visibile', mostra);
      barra.setAttribute('aria-hidden', mostra ? 'false' : 'true');
      // il pulsante del programma fedelta sta nello stesso angolo: gli si fa posto
      document.documentElement.classList.toggle('barra-prezzo-aperta', mostra);
    }

    // ricopia il valore, qualunque cosa lo cambi: nessun calcolo duplicato
    if (window.MutationObserver) {
      new MutationObserver(function () { numero.textContent = prezzo.textContent; })
        .observe(prezzo, { childList: true, characterData: true, subtree: true });
    }
    numero.textContent = prezzo.textContent;

    if (window.IntersectionObserver) {
      new IntersectionObserver(function (voci) {
        fuoriVista = !voci[0].isIntersecting;
        aggiorna();
      }, { threshold: 0.1 }).observe(riquadro);
    }

    ['input', 'change'].forEach(function (evento) {
      document.querySelector('.calculator-container').addEventListener(evento, function () {
        if (toccato) return;
        toccato = true;
        aggiorna();
      }, { passive: true });
    });

    // toccando la barra si torna al riquadro del prezzo
    barra.addEventListener('click', function () {
      riquadro.scrollIntoView({ block: 'center', behavior: 'smooth' });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
})();
